import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { buildMatchPath } from '@unicus/react-ui-kit';
import useAuth from 'core/hooks/useAuth';
import { THEME_TYPE_LITE } from '../../constants/themeSettings';

const SidebarContentRoute = ({
  pathname,
  routes,
  match,
  themeType,
  readOnly
}) => {
  const { isAuthenticated, user, isAdmin } = useAuth();

  const allowShow = (route) => {
    const { roles } = route;

    if (!isAuthenticated) {
      return false;
    }

    if (isAdmin()) {
      return true;
    }

    if (roles && !roles.some((c) => user.roles.includes(c) || c === '*')) {
      return false;
    }

    return true;
  };

  const replacePathBase = (path) => {
    return path.replace('/app', '').replace('/a', '');
  };

  const menu = (route, basePath, sub) => {
    if (
      route.routes &&
      route.isContainer !== false &&
      route.routes.find((c) => c.menu)
    ) {
      const key = (basePath || '') + route.path;

      return (
        <Menu.SubMenu key={key} title={route.title} disabled={readOnly}>
          {route.routes
            .filter((c) => c.menu)
            .map((c) => menu(c, route.path, true))}
        </Menu.SubMenu>
      );
    }

    let key = buildMatchPath(match, (basePath || '') + route.path);
    key = replacePathBase(key);

    return (
      <Menu.Item key={key} disabled={readOnly}>
        <Link to={`${buildMatchPath(match, (basePath || '') + route.path)}`}>
          <div className="gx-h-100">
            <span>{route.title}</span>
          </div>
        </Link>
      </Menu.Item>
    );
  };

  const defaultOpenKeys = [replacePathBase(pathname)];
  const keys = replacePathBase(pathname)
    .split('/')
    .filter((c) => !!c);

  if (keys.length > 1) {
    defaultOpenKeys.push(`/${keys[0]}`);
  }

  return (
    <Menu
      defaultOpenKeys={defaultOpenKeys}
      selectedKeys={defaultOpenKeys}
      theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
      mode="inline"
    >
      {routes &&
        routes
          .filter(
            (route) =>
              allowShow(route) && (route.menu || route.isContainer === false)
          )
          .map((route) => menu(route))}
    </Menu>
  );
};

export default SidebarContentRoute;
